// extracted by mini-css-extract-plugin
module.exports = {"loginLink":"styles_loginLink__3fEZg"};